const getTitlesToken = (user, account) => {
        return `${encodeURIComponent(user)}|${encodeURIComponent(account)}`;
}

export default getTitlesToken;
